import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { FaHistory, FaWindowClose, FaUserPlus, FaUserMinus } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { format } from '~/Utils/Helpers';

const ModalHistoricoAtribuicao = ({
  mostrarModal,
  setMostrarModal,
  codigoDocumentoDigital,
  numeroPreVenda
}) => {
  const [historico, setHistorico] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (mostrarModal && codigoDocumentoDigital) {
      buscarHistorico();
    }
  }, [mostrarModal, codigoDocumentoDigital]);

  const buscarHistorico = async () => {
    try {
      setCarregando(true);
      const response = await api.buscarHistoricoAtribuicaoDocumentoDigital(codigoDocumentoDigital);
      setHistorico(response || []);
    } catch (error) {
      console.error(error);
      toast.error('Erro ao buscar historico de atribuicoes');
    } finally {
      setCarregando(false);
    }
  };

  const getIconeEvento = (tipoEvento) => {
    switch (tipoEvento) {
      case 1:
        return <FaUserPlus color="#28a745" size={16} />;
      case 2:
        return <FaUserMinus color="#dc3545" size={16} />;
      default:
        return <FaHistory color="#6c757d" size={16} />;
    }
  };

  const getBadgeEvento = (tipoEvento, descricaoEvento) => {
    let bgColor;
    switch (tipoEvento) {
      case 1:
        bgColor = '#28a745';
        break;
      case 2:
        bgColor = '#dc3545';
        break;
      default:
        bgColor = '#6c757d';
    }

    return (
      <span
        className="badge px-2 py-1"
        style={{
          backgroundColor: bgColor,
          color: 'white',
          fontSize: '0.8em',
          fontWeight: '600',
          borderRadius: '4px'
        }}
      >
        {descricaoEvento}
      </span>
    );
  };

  return (
    <Modal
      show={mostrarModal}
      onHide={() => setMostrarModal(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaHistory color="#17a2b8" style={{ marginRight: '8px' }} />
          Historico de Atribuicoes
          {numeroPreVenda && (
            <span className="text-muted ml-2" style={{ fontSize: '0.7em' }}>
              (PV: {numeroPreVenda})
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {carregando ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Carregando historico...</p>
          </div>
        ) : historico.length === 0 ? (
          <div className="text-center py-4">
            <FaHistory color="#6c757d" size={48} />
            <p className="mt-3 text-muted">Nenhum registro de atribuicao encontrado</p>
          </div>
        ) : (
          <Table striped bordered hover responsive size="sm">
            <thead className="thead-light">
              <tr>
                <th style={{ width: '150px' }}>Data/Hora</th>
                <th style={{ width: '140px' }}>Evento</th>
                <th>Usuario</th>
                <th>Observacao</th>
              </tr>
            </thead>
            <tbody>
              {historico.map((item, index) => (
                <tr key={index}>
                  <td>
                    <small>{format.datetime(item.data)}</small>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      {getIconeEvento(item.tipo_evento)}
                      <span className="ml-1">
                        {getBadgeEvento(item.tipo_evento, item.descricao_evento)}
                      </span>
                    </div>
                  </td>
                  <td>
                    {item.nome_usuario ? (
                      <span
                        className="badge px-2 py-1"
                        style={{
                          backgroundColor: '#17a2b8',
                          color: 'white',
                          fontSize: '0.85em',
                          fontWeight: '600',
                          borderRadius: '4px'
                        }}
                      >
                        {item.nome_usuario}
                      </span>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <small className="text-muted">
                      {item.observacao || '-'}
                    </small>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => setMostrarModal(false)}
        >
          <FaWindowClose className="mr-1" />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHistoricoAtribuicao;
